import { Carousel as _Carousel } from "@mantine/carousel";
import "@mantine/carousel/styles.css";

const Carousel = _Carousel;
export default Carousel;
